/* eslint class-methods-use-this: 0 */
import _forEach from 'lodash/forEach';

// constants
import { AUTOCOMPLETE, AUTOCOMPLETE_SELECTED } from './Constants';

class AutocompleteUtils {
  constructor() {
    // https://developers.google.com/places/supported_types
    this.FORBIDDEN_TYPES = ['natural_feature'];
  }

  /**
   * @description On key press up and down navigates through the dropdown elements.
   *
   * @param {string} keyPressed - (ArrowUp|ArrowDown)
   *
   * @return {Object} hightlighted dom element.
   */
  highlightPlace(keyPressed) {
    const places = document.getElementById(AUTOCOMPLETE).childNodes;
    const className = AUTOCOMPLETE_SELECTED;
    const placesLen = places.length;
    let selectedPlace = 0;

    _forEach(places, (node, index) => {
      const elem = node;
      if (elem.className === className) {
        if (keyPressed === 'ArrowDown') {
          if (index < placesLen - 1) {
            selectedPlace = index + 1;
          } else {
            // If we reached the end of the dropdown go back to the beginning.
            selectedPlace = 0;
          }
        } else if (keyPressed === 'ArrowUp') {
          if (index > 0) {
            selectedPlace = index - 1;
          } else {
            // If we reached the top of the dropdown go to the end.
            selectedPlace = placesLen - 1;
          }
        }
        return false;
      }
      return true;
    });

    return places[selectedPlace];
  }

  /**
   * @description Formats Google Maps address components into a shorter address
   * for handheld devices.
   *
   * @param {Object} place - Location details
   *
   * @return {string} formatted short address for devices with less real estate.
   */
  getShortAddressFromAddressComponents(place) {
    const addressFragments = place.address_components;
    const shortAddresses = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i <= 2; i++) {
      if (addressFragments[i]) {
        shortAddresses.push(addressFragments[i].short_name);
      }
    }

    return shortAddresses.join(' ');
  }

  /**
   * @description Interfaces with Google Maps API to get details of the selected
   * location
   *
   * @param {function} cb - Method to invoke if results have been found
   * @param {Object=} field - DOM node
   *
   * @return {void}
   */
  getLocationDetails(address = '') {
    const { google } = window;
    const geocoder = new google.maps.Geocoder();

    return new Promise(resolve => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            const addressDetails = results[0];
            const searchInputElement = document.querySelector('.search-input');
            searchInputElement.value = addressDetails.formatted_address;

            const addressTypeMap = {
              locality: 'city',
              administrative_area_level_1: 'state',
              country: 'country',
              postal_code: 'zip',
            };

            const addressInfo = {};

            // Iterate through address details. If matching address types are found, populate the
            // addressInfo object.
            addressDetails.address_components.forEach(addressItem => {
              const addressType = addressItem.types.find(type => addressTypeMap[type]);
              if (addressType) addressInfo[addressTypeMap[addressType]] = addressItem.long_name;
            });

            const selectedSearchResult = {
              lat: addressDetails.geometry.location.lat(),
              lng: addressDetails.geometry.location.lng(),
              address: addressDetails.formatted_address,
              city: addressInfo.city || '',
              state: addressInfo.state || '',
              zip: addressInfo.zip || '',
              country: addressInfo.country || '',
              shortAddress: this.getShortAddressFromAddressComponents(addressDetails) || '',
              type: addressDetails.types[0] || '',
              isFullStreetAddress:
                addressDetails.address_components[0].types[0] === 'street_number',
            };

            return resolve(selectedSearchResult);
          }
        }

        return resolve(null);
      });
    });
  }

  /**
   * @description Get the address string from the focused autocomplete restule
   *
   * @param {Object=} field - DOM node
   *
   * @return {void}
   */
  getAddress(field = false) {
    const node = document.getElementsByClassName(AUTOCOMPLETE_SELECTED)[0];
    const address = field.value || node.innerText;
    return address;
  }
}

export default new AutocompleteUtils();
